export default __webpack_public_path__ + "static/media/cocktail.6696a66b.gif";